<template>
  <div>
    <LinkTitle></LinkTitle>
    <div id="creatOrder">
       <PageSearchTitle :hideCart="true" :hideSearch="true"></PageSearchTitle>
      <div class="address">
        <div class="addressTitle">
          <div class="addressTitleLeft">收货信息</div>
          <div @click="toAddAddress" class="addressTitleRight textHover">新增收货地址</div>
        </div>
        <div class="addressInfo">
          <div>
            <!-- 如果没有输入过信息 -->
            <div class="first">
              <el-form
                :model="addressForm"
                ref="addressForm"
                label-width="100px"
                size="small"
                class="demo-addressForm"
              >
                <el-form-item label="配送方式">
                  <el-radio v-model="sendWay" size="mini" label="1">物流配送</el-radio>
                  <el-radio v-model="sendWay" size="mini" label="2">到店自提</el-radio>
                </el-form-item>
                <div v-if="sendWay==1">
                  <div v-if="!address">
                    <Address @addSuccess="addSuccess" />
                  </div>
                  <div v-if="address">
                    <div
                      v-for="(item,index) in address"
                      :key="index+'aaa'"
                      :class="['addressBoxItem',item.checked?'showBorder':'']"
                      @click="checkAddress(index)"
                    >
                      <div class="addressBoxLeft">
                        <div :class="['addressBoxTitle',item.checked?'':'hidden' ]">
                          <i class="el-icon-location sendLogo"></i>
                          <span>寄送至</span>
                        </div>

                        <div
                          class="addressItem"
                          @mouseover="()=>showDefaultAddress(index)"
                          @mouseout="()=>hiddenDefaultAddress(index)"
                        >
                          <div class="addressItemLeft">
                            <el-radio size="small" v-model="selectedAddress" :label="String(index)">
                              <span></span>
                            </el-radio>
                            <div class="addressItemTag">{{item.name}}</div>
                            <div :class="[item.checked?'textWeight':'']">
                              <span>{{item.name}}</span>
                              <span>{{$getAreaInfo(item.areaId)[0]}}</span>
                              <span
                                v-show="$getAreaInfo(item.areaId)[0]!=$getAreaInfo(item.areaId)[1]"
                              >{{$getAreaInfo(item.areaId)[1]}}</span>
                              <span>{{$getAreaInfo(item.areaId)[2]}}</span>
                              <span>{{item.address}}</span>
                              <span>{{item.phone}}</span>
                            </div>
                          </div>
                          <div v-if="item.isDefault" class="addressItemRight">
                            <span>默认地址</span>
                          </div>
                          <div :ref="'setDefaultAddress'+index" class="setDefaultAddress" v-else>
                            <span v-if="item.checked">设置为默认地址</span>
                          </div>
                        </div>
                      </div>
                      <div class="addressBoxRight">
                        <span v-if="item.checked">修改本地址</span>
                      </div>
                    </div>
                    <!-- <div class="allAdress">
                      <span>全部地址</span>
                    </div>-->
                  </div>
                </div>
                <div v-if="sendWay==2">到店自提</div>
                
              </el-form>
            </div>
          </div>
        </div>
      </div>

      <div class="orderInfo">
        <div class="addressTitle addressTitleLeft">商品信息</div>
        <div>
          <div class="cartBox">
            <div class="cartBoxTitle">
              <ul class="cartBoxTitleTitleUl">
                <li class="cartBoxTitleTitleUlLiMainInfo">
                  <div class="cartBoxTitleTitleUlLiMainInfoText">商品信息</div>
                </li>
                <li class="cartBoxTitleTitleUlLiInfo"></li>
                <li class="cartBoxTitleTitleUlLiPrice">
                  <span>单价</span>
                </li>
                <li class="cartBoxTitleTitleUlLiNum">
                  <span>数量</span>
                </li>
                <li class="cartBoxTitleTitleUlLiMoney">
                  <span>小计</span>
                </li>
              </ul>
            </div>
            <div
              v-for="(storeItem,storeIndex) in goodsInfo"
              :key="'store_'+storeIndex"
              class="goodsItems"
            >
              <div class="goodsItemsTitle">
                <span class="goodsItemsTitleStore">店铺:</span>
                <span>{{storeItem[0].storeName}}</span>
              </div>
              <ul class="goodsItemsProductsBox">
                <li
                  v-for="(item,index) in storeItem"
                  :key="index"
                  :class="['goodsItemsProductsItems',index==0?'':'goodsItemsProductsItemsBorderTop']"
                >
                  <div class="goodsItemsProductsItemsMainInfo">
                    <img
                      @click="goGoodsDetail(item)"
                      class="goodsItemsProductsItemsMainInfoImg textHover"
                      :src="getImageUrl(item.coverPlan)"
                      alt
                    />
                    <div
                      @click="goGoodsDetail(item)"
                      class="goodsItemsProductsItemsMainInfoText"
                    >{{item.name}}</div>
                  </div>

                  <div class="goodsItemsProductsItemsInfo">
                    <div>
                      <span>产地：{{item.address}}</span>
                    </div>
                    <div>
                      <span>品种：{{item.breed}}</span>
                    </div>
                  </div>
                  <div class="goodsItemsProductsItemsPrice">
                    <span>&yen;{{(item.price).toFixed(2)}}</span>
                  </div>

                  <div class="goodsItemsProductsItemsNumber">
                    <!-- <el-input-number
                  :value="item.cart_num"
                  @change="(e)=>handleStempperChange(e,item)"
                  :min="item.minBuyCount"
                  :max="item.stockCount"
                  size="mini"
                    ></el-input-number>-->
                    <span>{{item.cart_num}}{{item.buyUnit}}</span>
                  </div>
                  <div class="goodsItemsProductsItemsMoney priceColor">
                    <span>&yen;{{(item.price*item.cart_num).toFixed(2)}}</span>
                  </div>
                  <!-- <div class="goodsItemsProductsItemsHandle">
                <span>移入收藏夹</span>
                <span @click="deleteItem(item)">删除</span>
                  </div>-->
                </li>
              </ul>
              
              <div class="itemFooter">
                <div class="fen addInvoiceModular">
                    <div class="invoiceShow">
                      <span>是否开具发票 </span>
        
                        <el-switch
                          v-model="switchOpen[storeIndex]"
                          >
                        </el-switch>  
              
                    </div>
                    <div class="fen1span" v-if="switchOpen[storeIndex]">
                      <span>发票抬头：</span> 
                      <el-button 
                        type="success" 
                        plain size="mini" 
                        style="padding:3px;" 
                        @click.native="addInvoicebut">
                        新建发票
                      </el-button><br>
                      
                      <el-select v-model="selectInvoice[storeIndex]" size="mini" placeholder="请选择">
                      <el-option
                        v-for="item in invoiceList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                        >
                      </el-option>
                    </el-select>
                    </div>
                    
                    
                  </div>
               
                
                <div  v-if="sendWay==2" class="getGoods fen">   
                    <div class="block">
                      <p class="demonstration">提货时间：</p>
                      <el-date-picker
                        v-model="value1[storeIndex]"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </div>
                  </div>
                <div class="itemFooterMessage fen">
                  
                  <div>
                    <div class="message">
                      <span>备 注&nbsp;:</span>
                      <el-input
                        type="textarea"
                        placeholder="选填,请先与商家协商一致"
                        v-model="textarea[storeIndex]"
                        maxlength="200"
                        rows="3"
                        show-word-limit
                      ></el-input>
                    </div>
                  
                  
                  </div>
                </div>
                <div class="storeTotalMoneyBox fen">
                  <div class="storeTotalMoney">
                    <span class="storeTotalMoneyTitle">店铺合计</span>
                    <span
                      class="storeTotalMoneyNum"
                    >&yen;{{$getCartInfo(cartList).data[storeIndex].storeMoney.toFixed(2)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-row>
            
          <el-dialog
          title="新增发票信息"
          :visible.sync="dialogVisible"
          width="40%"
          :show-close=false
          :close-on-click-modal=false>
          <el-form ref="form" :rules="rules" :model="form" label-width="100px" class="formStyle">
                  <el-form-item label="发票类型" prop="type">
                    <el-radio-group v-model="form.type">
                      <el-radio :label="1">普通发票</el-radio>
                      <el-radio :label="2">电子发票</el-radio>
                      <el-radio :label="3">增值税专用发票</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="发票信息" v-if="(form.type==3 ? false : true)" prop="resource">
                    <el-radio-group v-model="form.resource">
                      <el-radio :label="0">个人</el-radio>
                      <el-radio :label="1">企业</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="发票抬头" prop="title">
                    <el-input v-model="form.title"></el-input>
                  </el-form-item>
                  <el-form-item label="收票人手机号" prop="phone">
                     <el-input v-model="form.phone"></el-input>
                  </el-form-item>
                  <el-form-item label="纳税人识别号" 
                    v-if="(form.resource==1 ? true : false)||(form.type==3 ? true : false)" 
                    prop="tin"> 
                    <el-input v-model="form.tin"></el-input>
                  </el-form-item>
                  <el-form-item label="公司注册地址" v-if="form.type==3 ? true : false" prop="regurl">
                      <el-input v-model="form.regurl"></el-input>
                  </el-form-item>
                  <el-form-item label="开户银行名称" v-if="form.type==3 ? true : false" prop="bankName">
                      <el-input v-model="form.bankName"></el-input>
                  </el-form-item>
                  <el-form-item label="开户银行账号" v-if="form.type==3 ? true : false" prop="bankAccount">
                      <el-input v-model="form.bankAccount"></el-input>
                  </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="cancelInvoive">取 消</el-button>
              <el-button type="primary" @click="addInvoice(form)">确 定</el-button>
          </span>
          </el-dialog>
      </el-row>
      <div class="creatOrderFotter">
        <div class="creatOrderFotterBox">
          <div>
            <span class="creatOrderFotterBoxTitle">付款 :</span>
            <span class="yenLogo">&yen;</span>
            <span class="totalMoney">{{$getCartInfo(cartList).totalMoney.toFixed(2)}}</span>
          </div>

          <div v-if="sendWay==1">
            <span class="creatOrderFotterBoxTitle">寄送至 :</span>
            <span>{{checkedAddress&&$getAreaInfo(checkedAddress.areaId)[0]}}</span>
            <span>{{checkedAddress&&$getAreaInfo(checkedAddress.areaId)[1]}}</span>
            <span>{{checkedAddress&&$getAreaInfo(checkedAddress.areaId)[2]}}</span>
            <span>{{checkedAddress&&checkedAddress.address}}</span>
          </div>
          <div v-if="sendWay==1">
            <span class="creatOrderFotterBoxTitle">收货人 :</span>
            <span>{{checkedAddress&&checkedAddress.name}}</span>
            <span>{{checkedAddress&&checkedAddress.phone}}</span>
          </div>

          <div v-if="sendWay==2">
            <span class="creatOrderFotterBoxTitle">送货方式 :</span>
            <span>门店自提</span>
          </div>

          <div v-if="sendWay==2">
            <span class="creatOrderFotterBoxTitle">收货人 :</span>
            <span>{{this.userInfo.nickName}}</span>
            <span>{{this.userInfo.telephone}}</span>
          </div>
        </div>
      </div>
      <div class="creatOrderButtonBox">
        <div @click="submit" class="creatOrderButton">
          <span>提交订单</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageSearchTitle from '@/components/components/PageSearchTitle'
import {
  queryDefaultAddressUrlss,
  addAddressUrl,
  getImageUrl,
  queryAddressListUrl,
  addProductOrderUrl,
  addClassifyGoods,
  queryMyInvoiceUrl,
  addInvoiceUrl,
} from "@/api/api";
import { mapState } from "vuex";
export default {
  data() {
    return {
      address: null,
      style: { padding: "0 150px", minWidth: "1000px" },
      sendWay: "1",
      selectInvoice:[],
      addressForm: {},
      invoiceList:[],
      selectedAddress: "0",
      textarea: [],
      hovering: "",
      goodsInfo: null,
      value: '',
      value1:[],
      dialogVisible:false,
      switchOpen:[],
      form: {
        resource:0,
        type:1,
        title:'',
        phone:'',
        tin:'',
        regurl:'',
        bankName:'',
        bankAccount:'',
        },
      rules: {
        title: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
        ],
        tin: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  components:{PageSearchTitle},
  computed: {
    ...mapState(["userInfo", "cartList"]),

    checkedAddress() {
      if (this.address) {
        console.log(this.address);
        return this.address.filter(item => {
          return item.checked == 1;
        })[0];
      }
    }
  },
  mounted() {
    this.getInvoice();
    },
  methods: {
    submitForm(formName) {
      if (this.testAddAddres(this.addressForm)) {
        this.addAddress();
      }
    },
    exitDefaultAdreess(address) {
      if (address) {
        return address.some(item => {
          return item.isDefault == 1;
        });
      }
    },
    goGoodsDetail({ id }) {
      this.$router.push({
        name: "goodsDetail",
        query: {
          goodsId: id,
          type: -1
        }
      });
    },
    addSuccess() {
      this.$alert("添加成功!", { center: true, showClose: false }).then(() => {
        this.getAddressInfo();
      });
    },
    testAddAddres(form) {
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          let showTips = [];
          reg.forEach(item => {
            if (!item.rule.test(value)) {
              form[k].warning = item.info;
              flag = false;
              showTips.push(true);
            } else {
              showTips.push(false);
            }
          });
          showTips.every(item => item == false) && (form[k].warning = "");
        }
      }
      return flag;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getAddressInfo() {
      let url = queryAddressListUrl;
      let data = { access_token: this.userInfo.access_token };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      return this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          if (res.data.resultCode == 1) {
            let address = res.data.data;

            if (address && address.length) {
              if (this.exitDefaultAdreess(address)) {
                address.forEach(item => {
                  if (item.isDefault) {
                    item.checked = 1;
                  }
                });
              } else {
                address[0].isDefault = 1;
                address[0].checked = 1;
              }
              this.address = address;
            }
          } else {
            this.$alert(res.data.resultMsg,{center:true,showClose:false});
          }
        })
        .catch(err => {
          this.$alert(JSON.stringify(err),{center:true,showClose:false});
        });
    },

    showDefaultAddress(index) {},
    hiddenDefaultAddress(index) {
      // this.$refs["setDefaultAddress" + index][0].style.backgroundColor = "#fff";
    },
    getParams(type) {
      // ids
      // number
      // address_id
      // invoice_map
      // remark_map
      // sendTime_map
      let goodsInfo = this.goodsInfo;
      console.log("goodsInfo");
      console.log(goodsInfo);
      let ids = [];
      let number = [];
      goodsInfo.forEach(item => {
        item.forEach(item2 => {
          console.log("item2.id");
          console.log(item2.id);
          ids.push(item2.id);
          number.push(item2.cart_num);
        });
      });
      
      var obj={
        storeIdList:{
        },
        timeList:{
        },
        invoiveList:{
        }
      }
      for (var i=0;i < this.goodsInfo.length;i++){
        obj.storeIdList[this.goodsInfo[i][0].storeId]=this.textarea[i];
        obj.timeList[this.goodsInfo[i][0].storeId]=new Date(this.value1[i]);
        obj.invoiveList[this.goodsInfo[i][0].storeId]=this.selectInvoice[i];
        this.switchOpen[i]=false
      }
      
      let address_id = this.sendWay == 2 ? 1 : this.checkedAddress.id;
      let invoice_map = JSON.stringify(obj.invoiveList);
      let remark_map = JSON.stringify(obj.storeIdList);
      let sendTime_map = JSON.stringify(obj.timeList);

      return {
        ids: String(ids),
        number: String(number),
        address_id,
        invoice_map,
        remark_map,
        sendTime_map
      };
    },
    

    submit() {
      //  { ids, number, invoice_map: JSON.stringify(invoice_map), remark_map: JSON.stringify(remark_map), sendTime_map: JSON.stringify(sendTime_map) }
      console.log(this.checkedAddress);
      console.log("this.goodsInfo");
      console.log(this.goodsInfo);

      let type = this.judgeMixtureOrder(this.goodsInfo);
      let url = "";
      if (type == 1) {
        //普通商品
        url = addClassifyGoods;
      } else if (type == 2) {
        url = addProductOrderUrl;
      } else if (type == 3) {
        //白条和普通商品一起下单
        this.$alert("暂不支持白条类商品和普通类商品同时下单，请分开下单",{
          center:true,
          showClose:false
        });
        return;
      }

      // access_token
      // ids
      // number
      // address_id
      // invoice_map
      // remark_map
      // sendTime_map
      // address_id  //1为自提

      let data = {
        access_token: this.userInfo.access_token,
        ...this.getParams()
      };
      console.log(data);
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
            // this.clearCart()
            this.creatOrderSuccess(res.data.data);
          } else {
            this.$alert(res.data.resultMsg,{center:true,showClose:false});
          }
        })
        .catch(err => {
          alert(err.msg);
        });
    },

    creatOrderSuccess(data) {
      //需要判断是单个订单还是多个订单,多个订单跳转订单页,一个订单跳转支付页面
      //白条下单
      let {
        id,
        type,
        fm_status,
        totalMoney,
        order_id,
        pay_flag,
        trade_no,
        balance,
        store_name,
        prepayment,
        store_id
      } = data.o_list[0];
      if (data.o_list.length > 1) {
        this.$router.push("myOrder");
      } else {
        this.$router.push({
          name: "payPage",
          query: {
            id,
            order_id,
            totalMoney,
            prepayment,
            type,
            fm_status,
            pay_flag,
            store_name,
            store_id
          }
        });
      }
    },
    getInvoiceShow(){
      if(this.form.value2){
        this.getInvoice()
      }
    },
    getInvoice(){
        console.log("aaaaa");
        let that = this;
        let url = queryMyInvoiceUrl;
        let data = {
            access_token: this.userInfo.access_token,
        };
        let param = new URLSearchParams();
        for (var k in data) {
            param.append(k, data[k]);
        }
        this.$axios({
            method: "post",
            data: param,
            url,
        })
        .then((res) => {
        console.log(res);
        if (res.data.resultCode == 1) {
            let { data } = res.data;
            // console.log("dataf", data);
            this.invoiceList=data;
            this.loading=false;
        } else {
            this.$alert(res.data.resultMsg);
        }
        })
        .catch((err) => {
        this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });

    },
    cancelInvoive(){
        this.loading=false;
        this.$refs.form.resetFields();
        this.dialogVisible=false;
        this.$refs.form.resetFields();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.loading=false;
        })
        .catch(_ => {});
    },

    addInvoicebut(){
      console.log("aaa");
      this.id='';
      this.dialogVisible=true;
    },
  
    addInvoice(form){
        if(form.title.trim()==''){
          this.$alert("请输入发票抬头");
          return false
        }
        if(form.resource==1&&form.tin.trim()==''){
          this.$alert("请输入纳税人识别号");
          return false
        }
        this.$refs.form.validate(valid => {
        if (valid) {
             //如果通过验证 to do...
            this.loading=true;
            console.log(this.id)
            if(this.id==''){
              var url = addInvoiceUrl;
            }else{
              var url = updateInvoiceUrl;
            }
            
            let data = {
              type:this.form.type,
              title:this.form.title.trim(),
              phone:this.form.phone.trim(),
              tIN:this.form.tin.trim(),
              regurl:this.form.regurl.trim(),
              bankName:this.form.bankName.trim(),
              bankAccount:this.form.bankAccount.trim(),
              access_token: this.userInfo.access_token,
              id:this.id,
            };
            let param = new URLSearchParams();
            for (var k in data) {
                param.append(k, data[k]);
            }
            this.$axios({
                method: "post",
                data: param,
                url,
            })
            .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
                let { data } = res.data;
                this.invoiceList=data;
                
                this.$refs.form.resetFields();
                
                this.dialogVisible = false;
                this.form.resource=0;
                
                this.getInvoice();
            } else {
                this.$alert(res.data.resultMsg);
            }
            })
        } else {
          this.$alert("请输入发票抬头");
          return false
        }
      })
      },


    judgeMixtureOrder(goodsInfo) {
      let haveWhiteBar = false;
      let haveNormal = false;
      let type = 0; //1普通订单 2白条订单 3白条和普通商品一起
      goodsInfo.forEach(item => {
        item.forEach(item2 => {
          if (
            item2.breed.indexOf("白条") > -1 ||
            item2.goodsType.indexOf("白条") > -1
          ) {
            haveWhiteBar = true;
          } else {
            haveNormal = true;
          }
        });
      });
      if (!haveWhiteBar && haveNormal) {
        return (type = 1);
      } else if (haveWhiteBar && !haveNormal) {
        return (type = 2);
      } else if (haveWhiteBar && haveNormal) {
        return (type = 3);
      }
    },
    checkAddress(index) {
      let address = JSON.parse(JSON.stringify(this.address));
      this.selectedAddress = String(index);
      address.forEach(item => {
        item.checked = 0;
      });

      address[index].checked = 1;
      this.address = address;
      console.log(this.address[index]);
    },
    toAddAddress() {
      this.$router.push("settingPage");
    }
  },
  
  created() {
    this.getImageUrl = getImageUrl;
    this.goodsInfo = this.$filterCheckedCartInfo(this.cartList);
    console.log(this.goodsInfo)
    this.getAddressInfo();
  }
};
</script>

<style lang='less'>
@media screen and(min-width:320px) and(max-width:1200px) {
  #creatOrder {
    padding: 10px 10px 100px !important;
  }
}
.demonstration{
  margin-bottom: 8px;
}
#creatOrder {
  min-width: 1000px;
  padding: 10px 150px 100px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  .addressTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    /* // background-color: yellow; */
  }
  .addressTitleLeft {
    font-size: 16px;
    font-weight: 700;
  }
  .first {
    margin: 15px 0;
  }
  .addressInfoTitle {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 700;
  }
  .addressInfoWay {
    height: 50px;

    display: flex;
    align-items: center;
  }
  .addressInfoWayItems {
    width: 150px;
    height: 30px;
    box-sizing: border-box;
    background-color: #dd2727;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #aaa;
    font-size: 12px;
  }
  .checked {
    border-color: #dd2727;
  }

  .addressInfoWayItems:hover {
    cursor: pointer;
  }
  .addressFormInputItem {
    width: 300px;
  }
  .addressFormInputItem {
  }
  .addressFormItem {
    display: flex;
  }
  .warning {
    color: #dd2727;
    margin-left: 10px;
  }
  .addressItem {
    display: flex;
    height: 36px;
    align-items: center;
    // background-color: yellow;
  }
  .addressItemTag {
    border: 1px solid #666;
    padding: 0px 20px;
    margin-right: 20px;
    width: 120px;
    text-align: center;
  }
  .addressBoxItem {
    max-width: 1100px;
    height: 36px;
    display: flex;
    padding: 0 20px 0 0;
    border: 1px solid #fff;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .showBorder {
    border: 1px solid #dd2727;
    background-color: #fff0e8;
  }
  .hidden {
    visibility: hidden;
  }
  .addressBoxRight {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .addressBoxLeft {
    display: flex;
  }
  .totalMoney {
    color: #dd2727;
    font-size: 18px;
    font-weight: 700;
  }
  .addressBoxRight {
  }
  .addressBoxTitle {
    width: 100px;
    /* // background-color: red; */
    padding-right: 12px;
    box-sizing: border-box;
    color: #dd2727;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
  }
  .sendLogo {
    font-size: 14px;
  }
  .addressItemTag:hover {
    cursor: pointer;
  }

  .addressItemLeft {
    display: flex;
    align-items: center;
  }
  .addressItemLeft:hover {
    cursor: pointer;
  }
  .textWeight {
    font-weight: 700;
  }

  .setDefaultAddress {
    padding: 2px 5px;
    color: #3e71f7;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin-left: 20px;
  }
  .addressBoxRight {
    color: #3e71f7;
  }
  .setDefaultAddress:hover {
    cursor: pointer;
  }
  .addressItemRight {
    background-color: #3e71f7;
    padding: 2px 5px;
    color: #fff;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin-left: 20px;
  }
  .orderInfo {
  }
  .orderInfoTitle {
  }
  .allAdress {
  }
  .cartBoxTitleTitleUl {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
  }
  .cartBoxTitleTitleUlLiMainInfo {
    display: flex;
    flex-direction: row;
    width: 340px;
  }
  .cartBoxTitleTitleUlLiMainInfoChecked {
    width: 60px;
  }
  .cartBoxTitleTitleUlLiMainInfoText {
    width: 280px;
    text-align: center;
  }
  .cartBoxTitleTitleUlLiHandle {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiPrice {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiInfo {
    flex: 1;
    height: 100%;
  }
  .cartBoxTitleTitleUlLiNum {
    flex: 1;
    text-align: center;
  }
  .cartBoxTitleTitleUlLiMoney {
    width: 200px;
    margin-right: 10px;
    /* // background-color: blue; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .goodsItemsProductsItemsMainInfoImg {
    width: 100px;
    height: 100;
  }
  .goodsItemsTitle {
    height: 50px;

    display: flex;
    align-items: center;
  }

  .priceColor {
    color: #dd2727;
    font-weight: 700;
  }
  .cartTitleHr {
    height: 1px;
    background-color: #eee;
  }
  .cartTitleTop {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 60px;
    align-items: center;
    padding-right: 5px;
  }
  .cartTitleTopTips {
    margin-right: 10px;
  }
  .cartTitleTopPrice {
    margin-right: 10px;
    font-size: 14px;
    color: #dd2727;
  }
  .cartBoxTitleTitleUl {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    border-bottom: 5px solid #b2d1ff;
    margin-bottom: 20px;
  }
  .goodsItemsProductsItems {
    display: flex;
    flex-direction: row;
    height: 100px;
  }
  .goodsItemsProductsItemsMainInfo {
    display: flex;
    width: 300px;
  }
  .goodsItemsProductsItemsMainInfoImg {
    width: 100px;
    height: 100;
  }

  .goodsItemsProductsItemsMainInfoText {
    width: 190px;
    margin-left: 10px;

    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; 
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .goodsItemsProductsItemsMainInfoText:hover {
    color: #dd2727;
    text-decoration: underline;
    cursor: pointer;
  }
  .goodsItemsProductsItemsInfo {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #666;
  }
  .goodsItemsProductsItemsMoney {
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* // background-color: yellow; */
  }
  .goodsItemsProductsItemsNumber {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .goodsItemsProductsItemsHandle {
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 14px;
  }
  .goodsItemsProductsItemsHandle span:hover {
    color: #f30;
    text-decoration: underline;
    cursor: pointer;
  }
  .goodsItemsProductsBox {
    padding: 10px;
    background-color: #f1f6ff;
  }
  .goodsItemsProductsItemsCheckeBox {
    width: 30px;
    display: flex;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiMainInfo {
    display: flex;
    flex-direction: row;
    width: 340px;
  }
  .cartBoxTitleTitleUlLiMainInfoChecked {
    width: 60px;
  }
  .cartBoxTitleTitleUlLiMainInfoText {
    width: 280px;
    text-align: center;
  }
  .cartBoxTitleTitleUlLiHandle {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiPrice {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiInfo {
    flex: 1;
    height: 100%;
  }
  .cartBoxTitleTitleUlLiNum {
    flex: 1;
    text-align: center;
  }
  .goodsItemsProductsItemsPrice {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
  }
  .goodsItemsTitle {
    height: 50px;
    background-color: #fff;
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #999;
  }
  .goodsItemsTitleStore {
    margin: 0 10px;
  }
  .goodsItemsProductsItems {
    padding: 15px 0;
  }
  .goodsItemsProductsItemsBorderTop {
    border-top: 1px solid #eeeeee;
  }
  .cartTitle {
    margin-top: 10px;
  }

  .cartFooter {
    position: fixed;
    z-index: 10;
    bottom: 0;
    left: 0;
    background-color: #fff;
    display: flex;
    height: 60px;
    justify-content: space-between;
    width: 100%;
    padding-right: 150px;
    font-size: 14px;
    color: #666;
  }
  .cartFooterLeft {
    display: flex;
    align-items: center;
  }

  .cartFooterLeft {
    padding-left: 10px;
    margin-left: 150px;
    flex: 1;
    min-width: 500px;
    background-color: #e5e5e5;
  }
  .cartFooterRight {
    width: 600px;
    background-color: green;
    margin-right: 150px;
    flex: 1;
    min-width: 500px;
    background-color: #e5e5e5;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .cartFooterLeftItems {
    margin-right: 15px;
  }
  .cartFooterLeftItems:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .cartFooterRightNum,
  .cartFooterRightPrice {
    margin-left: 30px;
  }
  .cartFooterRightButton {
    margin-left: 30px;
    height: 100%;
    background-color: #dd2727;
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
  }
  .cartFooterRightButton:hover {
    cursor: pointer;
  }

  .cartFooterRightButtonDisabled {
    background-color: #999;
  }
  .cartFooterRightButtonDisabled:hover {
    cursor: not-allowed;
  }

  .cartFooterRightNumber {
    font-size: 16px;
    color: #dd2727;
    margin: 0 5px;
  }
  .cartFooterRightPriceYen {
    color: #dd2727;
  }
  .cartFooterRightPriceNum {
    color: #dd2727;
    font-size: 16px;
    font-weight: 700;
  }
  .cartTitleTopButton {
    background-color: #dd2727;
    width: 50px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 2px;
    font-size: 12px;
  }
  .cartTitleTopButton:hover {
    cursor: pointer;
  }
  .message {
    width: 260px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .storeTotalMoneyBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 10px;
    height: 50px;
    /* // background-col or: pink; */
  }
  .storeTotalMoney {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 200px;
  }
  .storeTotalMoneyTitle {
    font-size: 14px;
    color: #333;
  }
  .storeTotalMoneyNum {
    margin-left: 15px;
    color: #dd2727;
    font-weight: 700;
    font-size: 16px;
  }
  .itemFooter {
    padding: 10px;
    display: flex;
  }
  .itemFooter .fen {
    flex: 1;
  }
  .itemFooter .fen1 {
    flex: 2;
  }
  .itemFooter .fen1 .el-tooltip{
    margin-left: 10px;
  }
  .fen1span{
    margin-top: 8px;
  }
  .fen1span .el-select{
    width: 120px;
    margin-top: 5px;
    /* border: #2a27dd; */
  }
  .fen1span .el-select .el-input{
    border-color: aqua;
  }
  .invoiceShow{
    margin-top: 8px;
    display: inline-block;
    width: 155px;
  }
  .goodsItems {
    border-bottom: 1px dashed #999;
    margin-bottom: 20px;
    background-color: #f1f6ff;
  }
  .creatOrderFotter {
    display: flex;
    justify-content: flex-end;
  }
  .creatOrderFotterBox {
    min-width: 300px;
    padding: 10px;
    border: 1px solid #dd2727;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-around;
    height: 80px;
    font-size: 14px;
  }
  .creatOrderButtonBox {
    display: flex;
    justify-content: flex-end;
  }
  .creatOrderFotterBoxTitle {
    font-weight: 700;
  }
  .creatOrderButton {
    width: 180px;
    height: 40px;
    background-color: #dd2727;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .creatOrderButton:hover {
    cursor: pointer;
  }
  .itemFooterMessage {
    display: flex;
  }
  .addressTitleRight{
    color:#f70 
  }
}
.getGoods{
  margin-left: 10px;
}
.addInvoiceModular{
  margin-left: 20px;
}
</style>
<style>
.fen1span .el-input__inner:focus{
  border-color:#009e96 !important
}
.fen1span .el-button--success.is-plain {
  color: #009e96!important;
  border-color: #009e96!important;
  background-color: #009e963d!important;
}
.getGoods .block div input:focus{
  border-color:#009e96 !important
}
.itemFooterMessage  .message .el-textarea textarea:focus{
  border-color:#009e96 !important
}
.itemFooterMessage  .message .el-textarea textarea{
  margin-top: 8px;
}


.fen1span .el-input--mini .el-input__inner{
  margin-top: 5px !important;
  padding-left: 6px !important;
  width: 130px !important;
}
.fen1span  .el-input__suffix{
  margin-top: 2px !important;
  margin-right: -15px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/CreatOrder/CreatOrder.vue